import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `RegistroAlimentacion/editAlimentacion`, method: 'POST', body: values, token: token})
}
